<div oui-dialog-title>
  Modifier un document
  <oui-button type="icon" oui-dialog-close>
    <oui-icon>close</oui-icon>
  </oui-button>
</div>

<oui-dialog-content class="padding-24" [scroll]="true">
  <div class="flex-vertical flex-start gap-24 flex-center justify-center" *ngIf="!isloading">
    <oui-file-uploader
      class="width-100pc"
      type="multi"
      accept="application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/pdf"
      [(value)]="files"
      [maxFileSize]="19"
      hint="Fichiers supportés : pdf ou word / Taille max : 19 Mo"></oui-file-uploader>
    <div class="files-container" *ngIf="(files?.length ?? 0) > 0">
      <oui-file-item
        *ngFor="let file of files"
        [file]="file"
        (delete)="deleteFile(file)"
        (fileClick)="onFileClick($event)"></oui-file-item>
    </div>
  </div>
  <div class="flex-horizontal flex-center justify-center">
    <oui-loading *ngIf="isloading"></oui-loading>
  </div>
</oui-dialog-content>

<oui-dialog-actions>
  <oui-button type="text" oui-dialog-close> Annuler </oui-button>
  <oui-button type="contained" (click)="onValid()" [disabled]="!isloading && !files"> Valider </oui-button>
</oui-dialog-actions>
